import type { TeamSegment } from "./types";

export const TEAM_SEGMENT_OPTIONS: { value: TeamSegment; label: string }[] = [
  { value: "staff", label: "Staff" },
  { value: "teams", label: "Teams" },
];

export const DEFAULT_TEAM_SEGMENT: TeamSegment = "staff";

export function parseTeamSegment(raw: string | null): TeamSegment {
  if (raw === "teams") {
    return "teams";
  }

  return DEFAULT_TEAM_SEGMENT;
}
